import { ADMIN_COMPANY_PROFILER_ROLES, ROLE_PROMOTER, ROLE_TEAM_LEADER } from '@domain/company';
import type { AuthContextResponse } from '@hooks/auth/type';
import type { SetProfilerRequest } from '@hooks/profiler/use-set-profiler.type';

/**
 * The profiler groups a session belongs to, in the order they are sent. A super-admin sends one
 * empty group, which clears it. The company group needs the legacy company id from the URL and is
 * skipped on the routes that sit outside a company.
 */
export const getProfilerGroups = (
  response: AuthContextResponse,
  {
    companyId,
    isOutsideCompany,
    selectedTeamId,
  }: { companyId: string; isOutsideCompany: boolean; selectedTeamId?: string }
): SetProfilerRequest[] => {
  if (response.user.isSuperAdmin) return [{}];

  const roleName = response.role.name;
  const groups: SetProfilerRequest[] = [];
  if (roleName === ROLE_PROMOTER) {
    groups.push({ groupType: 'promoter', groupId: response.channels[0].id });
  }
  if (roleName === ROLE_TEAM_LEADER) {
    groups.push({
      groupType: 'promoterManager',
      groupId: selectedTeamId ? Number.parseInt(selectedTeamId) : response.teams[0].id,
    });
  }
  if (ADMIN_COMPANY_PROFILER_ROLES.includes(roleName) && !isOutsideCompany && !!companyId) {
    groups.push({ groupType: 'company', groupId: Number(companyId) });
  }
  return groups;
};
